import { setDefaultZoomAction as setDefaultZoomOperation } from 'editor/src/store/editorModules/panAndZoom/slice';

export default setDefaultZoomOperation;
